import { createRouter, createWebHistory } from "vue-router";
import { setAuditScreen } from "@/utils/clientHeaders";
import { message } from "ant-design-vue";
import { MENU_PERMS, canMenu, permsOf } from "@/utils/perm";
import { routeDeniedText } from "@/utils/standardErrors";

import Dashboard from "../views/Dashboard.vue";
import Signin from "../views/Signin.vue";
import StorageManagement from "../views/Storage/StorageManagement.vue";
import FileUpload from "../views/Storage/FileUpload.vue";

import HosManage from "../views/HospitalManagement/HosManage.vue";
import HosAccManage from "../views/HospitalManagement/HosAccManage.vue";
import HosCrawlManage from "../views/HospitalCrawling/HosCrawlManage.vue";
import HospitalAdManage from "../views/HospitalAd/HospitalAdManage.vue";

import ManuManage from "../views/ManufacturerManagement/ManuManage.vue";
import ManuAccManage from "../views/ManufacturerManagement/ManuAccManage.vue";
import MenuManage from "../views/MenuManage/MenuManage.vue";

import ResellerManage from "../views/ResellerManagement/ResellerManage.vue";
import ResellerAccManage from "../views/ResellerManagement/ResellerAccManage.vue";

import StudioManage from "../views/StudioManagement/StudioManage.vue";

import CategoryManage from "../views/CategoryManagement/CategoryManage.vue";
import CategoryForm from "../views/CategoryManagement/CategoryForm.vue";

import SubscriptionList from "../views/Subscriptions/plasmapp/SubscriptionList.vue";
import SubscriptionProductList from "../views/Subscriptions/products/ProductList.vue";
import UpsertSubscription from "../views/Subscriptions/centerflow/UpsertSubscription.vue";
import CenterflowSubscriptionList from "../views/Subscriptions/centerflow/SubscriptionList.vue";
import ProductMasterList from "../views/Subscriptions/product-masters/ProductMasterList.vue";

import CustomerManage from "../views/History/CustomerManage.vue";
import HistoryManage from "../views/History/HistoryManage.vue";
import ClaraManage from "../views/History/ClaraManage.vue";

import CertiAccManage from "../views/CertiAccManage.vue";
import AppVersionManage from "../views/AppVersionManage.vue";
import WebVersionManage from "../views/WebVersionManage.vue";

import NoticesList from "../views/NoticesList.vue";
import NoticeWrite from "../views/NoticeWrite.vue";
import NoticeModify from "../views/NoticeModify.vue";
import NoticeRead from "../views/NoticeRead.vue";

import ItemsList from "../views/ItemsList.vue";
import AddItem from "../views/AddItem.vue";
import ItemBulkEdit from "../views/ItemBulkEdit.vue";

// 인증서 시술 등록
import CertificateSurgeryRegistration from "../views/CertificateSurgery/CertificateSurgeryRegistration.vue";

// 인증서 이미지 관리
import CertificateImageManagement from "../views/CertificateImage/CertificateImageManagement.vue";

import ProductsList from "../views/Products/ProductsList.vue";

// 시스템 제품 관리 페이지 import
import SystemProductList from "../views/SystemProducts/SystemProductList.vue";

// 구독 상품 관리 페이지 import
import SubscriptionPackageList from "../views/SubscriptionPackages/SubscriptionPackageList.vue";

// 구독 관리 V2 페이지 import
import SubscriptionManagementV2 from "../views/SubscriptionsV2/SubscriptionManagementV2.vue";
import SubscriptionDetailV2 from "../views/SubscriptionsV2/SubscriptionDetailV2.vue";
import UpsertSubscriptionV2 from "../views/SubscriptionsV2/UpsertSubscriptionV2.vue";
import PaymentHistoryV2 from "../views/SubscriptionsV2/PaymentHistoryV2.vue";

import Monitoring from "../views/Monitoring.vue";
import Whitelist from "../views/CertiManage/Whitelist.vue";
import SendWhitelistManage from "../views/CertiManage/SendWhitelist/SendWhitelistManage.vue";

import LaborContracts from "../views/Contracts/LaborContracts.vue";
import ConsentContracts from "../views/Contracts/ConsentContracts.vue";

import TokenManage from "../views/KakaoService/token/TokenManage.vue";
import AlimtalkResults from "../views/KakaoService/AlimtalkResults.vue";
import SeolbiAlimtalkTracking from "../views/KakaoService/SeolbiAlimtalkTracking.vue";
import AfterdocMigration from "../views/KakaoService/AfterdocMigration.vue";
import MessageRoutes from "../views/KakaoService/MessageRoutes.vue";

import store from "../store";

// Order 관련 컴포넌트 import
import OrderContainer from "../views/Order/OrderContainer.vue";

import EnvironmentsList from "../views/Environments/EnvironmentsList.vue";

// 쿠폰 공급사 관리 페이지 import
import CouponProviderManage from "../views/CouponProvider/CouponProviderManage.vue";

// Event 관련 컴포넌트 import
import EventManagement from "../views/Events/EventManagement.vue";
import UpsertEvent from "../views/Events/UpsertEvent.vue";
import EventBlackPatientManage from "../views/Events/EventBlackPatientManage.vue";
import EventStatistics from "../views/Events/EventStatistics.vue";
import EventParticipationManage from "../views/Events/EventParticipationManage.vue";

// AI 프롬프트 관리 페이지 import
import AiPromptManagement from "../views/AiPrompt/AiPromptManagement.vue";

// 후기 관리 페이지 import
import ReviewManagement from "../views/Review/ReviewManagement.vue";

// 배너 관리 페이지 import
import BannerManagement from "../views/Banner/BannerManagement.vue";

// 예약 관리 페이지 import
import ReservationManagement from "../views/HospitalReservation/ReservationManagement.vue";

// 챗봇 관리 페이지 import
import CounselorManage from "../views/Chatbot/CounselorManage.vue";

// 콜봇 관리 페이지 import
import ExtensionManage from "../views/Callbot/ExtensionManage.vue";

// 콜봇 월 정산 페이지 import
import SettlementList from "../views/Callbot/Settlement/SettlementList.vue";
import SettlementRates from "../views/Callbot/Settlement/SettlementRates.vue";
import SettlementDetail from "../views/Callbot/Settlement/SettlementDetail.vue";

// 병원검색 제외 키워드 관리 페이지 import
import HospitalSearchKeywordManage from "../views/HospitalSearchKeyword/HospitalSearchKeywordManage.vue";

// 커넥터 관리 페이지 import
import ConnectorManage from "../views/CertilifeConnector/ConnectorManage.vue";

// 프로모션 통합 관리 페이지 import
import PromotionManagement from "../views/PromotionManagement/PromotionManagement.vue";
import PromotionEntries from "../views/PromotionManagement/PromotionEntries.vue";

// QR코드 관리 페이지 import
import QrManage from "../views/QrManagement/QrManage.vue";

// 홈페이지 편집기 import
import HomepageEditor from "../views/HomepageManagement/HomepageEditor.vue";

// 고객 도구 - 대리 로그인
import ImpersonateCustomer from "../views/CustomerTools/ImpersonateCustomer.vue";


const routes = [
  {
    path: "/",
    name: "/",
    redirect: "/signin",
  },
  {
    path: "/signin",
    name: "signIn",
    component: Signin,
  },
  {
    path: "/dashboard",
    name: "dashboard",
    component: Dashboard,
  },

  // 병원 계정 관리
  {
    path: "/hospital",
    name: "hospital",
    redirect: "/hospital/management",
    children: [
      {
        path: "management",
        name: "hosManage",
        component: HosManage,
      },
      {
        path: "account",
        name: "hosAccManage",
        component: HosAccManage,
      },
      {
        path: "crawling",
        name: "hosCrawlManage",
        component: HosCrawlManage,
      },
      {
        path: "ad",
        name: "hospitalAdManage",
        component: HospitalAdManage,
      },
    ],
  },

  // 제조사 계정 관리
  {
    path: "/manufacturer",
    name: "manufacturer",
    redirect: "/manufacturer/management",
    children: [
      {
        path: "management",
        name: "manuManage",
        component: ManuManage,
      },
      {
        path: "account",
        name: "manuAccManage",
        component: ManuAccManage,
      },
      {
        path: "menu",
        name: "MenuManage",
        component: MenuManage,
      },
    ],
  },

  // CRM 관리: 제조사 연결 병원에 CRM 시나리오 일괄 배포 + 가이드 템플릿
  {
    path: "/crm",
    name: "crm",
    redirect: "/crm/central-scenarios",
    children: [
      {
        path: "central-scenarios",
        name: "centralScenarioList",
        component: () => import("../views/CentralScenario/CentralScenarioList.vue"),
      },
      {
        path: "central-scenarios/:id",
        name: "centralScenarioDetail",
        component: () => import("../views/CentralScenario/CentralScenarioDetail.vue"),
      },
      // 가이드 템플릿: 병원 Studio '새로 만들기'에 보이는 안내형 설정 기본값
      {
        path: "setup-guides",
        name: "setupGuideList",
        component: () => import("../views/SetupGuide/SetupGuideList.vue"),
      },
      {
        path: "setup-guides/:id",
        name: "setupGuideDetail",
        component: () => import("../views/SetupGuide/SetupGuideDetail.vue"),
      },
    ],
  },

  // 기공소 계정 관리
  {
    path: "/dental-laboratory",
    name: "dentalLaboratory",
    redirect: "/dental-laboratory/management",
    children: [
      {
        path: "management",
        name: "dentalLabManage",
        component: ManuManage,
      },
      {
        path: "account",
        name: "dentalLabAccManage",
        component: ManuAccManage,
      },
    ],
  },

  // 리셀러 관리
  {
    path: "/reseller",
    name: "reseller",
    redirect: "/reseller/management",
    children: [
      {
        path: "management",
        name: "resellerManage",
        component: ResellerManage,
      },
      {
        path: "account",
        name: "resellerAccManage",
        component: ResellerAccManage,
      },
    ],
  },

  // STUDIO 관리
  {
    path: "/studio",
    name: "studio",
    redirect: "/studio/management",
    children: [
      {
        path: "management",
        name: "studioManage",
        component: StudioManage,
      },
      {
        path: "account",
        name: "studioAccManage",
        component: () => import("../views/StudioManagement/StudioAccManage.vue"),
      },
      {
        path: "quick-reply-master",
        name: "quickReplyMasterManage",
        component: () => import("../views/QuickReplyMaster/QuickReplyMasterManage.vue"),
      },
    ],
  },

  // 카테고리 관리
  {
    path: "/category",
    name: "category",
    redirect: "/category/management",
    children: [
      {
        path: "management",
        name: "categoryManage",
        component: CategoryManage,
      },
      {
        path: "create",
        name: "categoryCreate",
        component: CategoryForm,
      },
      {
        path: "edit/:id",
        name: "categoryEdit",
        component: CategoryForm,
      },
    ],
  },

  // 인증서 시술 등록
  {
    path: "/certificate-surgery",
    name: "certificateSurgery",
    redirect: "/certificate-surgery/registration",
    children: [
      {
        path: "registration",
        name: "certificateSurgeryRegistration",
        component: CertificateSurgeryRegistration,
      },
    ],
  },

  // 인증서 이미지 관리
  {
    path: "/certificate-image/management",
    name: "certificateImageManagement",
    component: CertificateImageManagement,
  },

  // 근로계약서 관리
  {
    path: "/contract/labor",
    name: "laborContracts",
    component: LaborContracts,
  },
  {
    path: "/contract/consent",
    name: "consentContracts",
    component: ConsentContracts,
  },

  // 인증서 관리
  {
    path: "/certificate",
    name: "certificate",
    redirect: "/certificate/customers",
    children: [
      {
        path: "customers",
        name: "customerManage",
        component: CustomerManage,
      },
      {
        path: "history",
        name: "historyManage",
        component: HistoryManage,
      },
      {
        path: "clara",
        name: "claraManage",
        component: ClaraManage,
      },
    ],
  },

  // 고객 도구
  {
    path: "/customer-tools",
    name: "customerTools",
    redirect: "/customer-tools/impersonate",
    children: [
      {
        path: "impersonate",
        name: "impersonateCustomer",
        component: ImpersonateCustomer,
      },
    ],
  },

  // 구독관리
  {
    path: "/salesrecords",
    name: "salesrecords",
    redirect: "/salesrecords/subscription",
    children: [
      {
        path: "subscription",
        name: "subscription",
        component: SubscriptionList,
      },
      {
        path: "subscription/create",
        name: "createSubscription",
        component: UpsertSubscription,
      },
      {
        path: "subscription/:id/edit",
        name: "editSubscription",
        component: UpsertSubscription,
      },
      {
        path: "centerflow-subscription",
        name: "centerflowSubscription",
        component: CenterflowSubscriptionList,
      },
      {
        path: "centerflow-subscription/create",
        name: "createCenterflowSubscription",
        component: UpsertSubscription,
      },
      {
        path: "centerflow-subscription/:id/edit",
        name: "editCenterflowSubscription",
        component: UpsertSubscription,
      },
      {
        path: "products",
        name: "subscriptionProducts",
        component: SubscriptionProductList,
      },
      {
        path: "product-masters",
        name: "productMasters",
        component: ProductMasterList,
      },
    ],
  },
  // 배치 모니터링
  {
    path: "/monitoring",
    name: "monitoring",
    component: Monitoring,
  },

  // 카카오 서비스 관리
  {
    path: "/alimtalk",
    name: "alimtalk",
    redirect: "/alimtalk/token",
    children: [
      {
        path: "token",
        name: "tokenManage",
        component: TokenManage,
      },
      {
        path: "results",
        name: "alimtalkResults",
        component: AlimtalkResults,
      },
      {
        path: "seolbi-tracking",
        name: "seolbiAlimtalkTracking",
        component: SeolbiAlimtalkTracking,
      },
      {
        path: "message-routes",
        name: "messageRoutes",
        component: MessageRoutes,
      },
    ],
  },

  // 마이그레이션
  {
    path: "/migration",
    name: "migration",
    redirect: "/migration/afterdoc",
    children: [
      {
        path: "afterdoc",
        name: "migrationAfterdoc",
        component: AfterdocMigration,
      },
      {
        path: "kakao-biz-1to1",
        name: "migrationKakaoBiz1to1",
        component: () => import("../views/KakaoService/KakaoBiz1to1Migration.vue"),
      },
    ],
  },

  // 서티라이프 관리
  {
    path: "/certilife",
    name: "certilife",
    redirect: "/certilife/account",
    children: [
      {
        path: "account",
        name: "certiAccManage",
        component: CertiAccManage,
      },
      {
        path: "version",
        name: "Version",
        redirect: "/certilife/version/app",
        children: [
          {
            path: "app",
            name: "AppVersionManage",
            component: AppVersionManage,
          },
          {
            path: "web",
            name: "webVersionManage",
            component: WebVersionManage,
          },
        ],
      },

      {
        path: "notice",
        name: "notice",
        redirect: "/certilife/notice/list",
        children: [
          {
            path: "list",
            name: "noticesList",
            component: NoticesList,
          },
          {
            path: "write",
            name: "noticeWrite",
            component: NoticeWrite,
          },
          {
            path: ":id",
            name: "noticeRead",
            component: NoticeRead,
          },
          {
            path: ":id/edit",
            name: "noticeModify",
            component: NoticeModify,
          },
        ],
      },
      {
        path: "whitelist",
        name: "whitelist",
        component: Whitelist,
      },
      {
        path: "send-whitelist",
        name: "sendWhitelist",
        component: SendWhitelistManage,
      },
      // 이용 내역(W6 A2, 계약 AUDIT 6-2) — 메뉴는 ops.audit.view, 조회는 서버가 판정
      {
        path: "audit-logs",
        name: "auditLogs",
        meta: { menu: "auditLogs" },
        component: () => import("../views/CertiManage/AuditLog/AuditLogManage.vue"),
      },
      // 이용 내역 점검(월 1회, W6 A8 — 계약 AUDIT 6-3)
      {
        path: "audit-checks",
        name: "auditChecks",
        meta: { menu: "auditChecks" },
        component: () => import("../views/CertiManage/AuditLog/AuditCheck.vue"),
      },
      // 막혔을 요청(T-CONTRACT-1031 §3) — 메뉴·조회 모두 ops.security.manage(검사 모드와 같음)
      {
        path: "perm-observations",
        name: "permObservations",
        meta: { menu: "permObservations" },
        component: () => import("../views/CertiManage/PermObservations.vue"),
      },
      // 국외 허용 IP(SPEC-SENDCERT-001 D-138)
      {
        path: "geo-allow-ips",
        name: "geoAllowIps",
        component: () => import("../views/CertiManage/GeoAllowIp/GeoAllowIpManage.vue"),
      },
      {
        path: "environments",
        name: "environments",
        component: EnvironmentsList,
      },
      {
        path: "coupon-providers",
        name: "couponProviderManage",
        component: CouponProviderManage,
      },
      {
        path: "manual-coupons",
        name: "manualCouponDistribution",
        component: () => import("../views/ManualCouponDistribution/index.vue"),
      },
      {
        path: "connector",
        name: "connectorManage",
        component: ConnectorManage,
      },
    ],
  },

  {
    // 품목관리
    path: "/item",
    name: "Item",
    redirect: "/item/list",
    children: [
      {
        path: "list",
        name: "ItemList",
        component: ItemsList,
        class: "is-active",
      },
      {
        path: "add",
        name: "AddItem",
        component: AddItem,
      },
      {
        path: "modify/:itemId",
        name: "ModifyItem",
        component: AddItem,
      },
      {
        path: "bulk-edit",
        name: "ItemBulkEdit",
        component: ItemBulkEdit,
      },
    ],
  },
  {
    // 제품관리 (레거시 - 인증서 제품)
    path: "/product-list",
    name: "ProductsList",
    component: ProductsList,
  },
  {
    // 시스템 제품 관리
    path: "/system-products",
    name: "SystemProductList",
    component: SystemProductList,
  },
  {
    // 구독 상품 관리
    path: "/subscription-packages",
    name: "SubscriptionPackageList",
    component: SubscriptionPackageList,
  },
  {
    path: "/subscriptions-v2",
    name: "subscriptionsV2",
    redirect: "/subscriptions-v2/list",
    children: [
      {
        path: "list",
        name: "subscriptionManagementV2",
        component: SubscriptionManagementV2,
      },
      {
        path: "payment-history",
        name: "paymentHistoryV2",
        component: PaymentHistoryV2,
      },
      {
        path: "create",
        name: "createSubscriptionV2",
        component: UpsertSubscriptionV2,
      },
      {
        path: ":id",
        name: "subscriptionDetailV2",
        component: SubscriptionDetailV2,
      },
      {
        path: ":id/edit",
        name: "editSubscriptionV2",
        component: UpsertSubscriptionV2,
      },
    ],
  },
  // 제조사 프로모션 통합 관리
  {
    path: "/promotions",
    name: "promotions",
    redirect: "/promotions/management",
    children: [
      {
        path: "management",
        name: "promotionManagement",
        component: PromotionManagement,
      },
      {
        path: ":promotionId/entries",
        name: "promotionEntries",
        component: PromotionEntries,
      },
    ],
  },
  {
    path: "/:pathMatch(.*)*",
    redirect: "/dashboard",
  },
  // 주문관리 route 추가
  {
    path: "/orders",
    name: "orders",
    redirect: "/orders/management",
    children: [
      {
        path: "management",
        name: "orderManagement",
        component: OrderContainer,
      },
    ],
  },
  // 이벤트관리 route 추가
  {
    path: "/events",
    name: "events",
    redirect: "/events/management",
    children: [
      {
        path: "management",
        name: "eventManagement",
        component: EventManagement,
      },
      {
        path: "create",
        name: "createEvent",
        component: UpsertEvent,
      },
      {
        path: ":id/edit",
        name: "editEvent",
        component: UpsertEvent,
      },
      {
        path: "black-patient",
        name: "eventBlackPatientManage",
        component: EventBlackPatientManage,
      },
      {
        path: "statistics/:eventId",
        name: "eventStatistics",
        component: EventStatistics,
      },
      {
        path: "ai-prompt",
        name: "aiPromptManagement",
        component: AiPromptManagement,
      },
      {
        path: "review",
        name: "reviewManagement",
        component: ReviewManagement,
      },
      {
        path: "participation",
        name: "eventParticipationManage",
        component: EventParticipationManage,
      },
    ],
  },
  // 자료실 라우터 추가
  {
    path: "/storage",
    name: "storage",
    component: StorageManagement,
  },
  // 파일 업로드 페이지 라우트 추가
  {
    path: "/storage/upload",
    name: "fileUpload",
    component: FileUpload,
  },
  // 배너 관리 라우터 추가
  {
    path: "/banner",
    name: "banner",
    redirect: "/banner/management",
    children: [
      {
        path: "management",
        name: "bannerManagement",
        component: BannerManagement,
      },
    ],
  },
  // 예약 관리 라우터 추가
  {
    path: "/reservation",
    name: "reservation",
    redirect: "/reservation/management",
    children: [
      {
        path: "management",
        name: "reservationManagement",
        component: ReservationManagement,
      },
    ],
  },
  // 챗봇 관리 라우터 추가
  {
    path: "/chatbot",
    name: "chatbot",
    redirect: "/chatbot/counselor",
    children: [
      {
        path: "counselor",
        name: "counselorManage",
        component: CounselorManage,
      },
    ],
  },
  // 콜봇 관리 라우터
  {
    path: "/callbot",
    name: "callbot",
    redirect: "/callbot/extensions",
    children: [
      {
        path: "extensions",
        name: "callbotExtensionManage",
        component: ExtensionManage,
      },
      // 월 정산 — 정적 경로(settlement, settlement/rates)를 :companyId 보다 먼저 둔다
      // ("rates" 가 회사 id 로 잡히지 않게)
      {
        path: "settlement",
        name: "callbotSettlementList",
        component: SettlementList,
      },
      {
        path: "settlement/rates",
        name: "callbotSettlementRates",
        component: SettlementRates,
      },
      {
        path: "settlement/:companyId",
        name: "callbotSettlementDetail",
        component: SettlementDetail,
      },
    ],
  },
  // 병원검색 제외 키워드 관리 라우터
  {
    path: "/hospital-search-keyword",
    name: "hospitalSearchKeyword",
    redirect: "/hospital-search-keyword/manage",
    children: [
      {
        path: "manage",
        name: "hospitalSearchKeywordManage",
        component: HospitalSearchKeywordManage,
      },
    ],
  },
  {
    path: "/tracking",
    name: "tracking",
    children: [
      {
        path: "info",
        name: "trackingInfo",
        component: () => import("../views/Tracking/TrackingInfo.vue"),
      },
      {
        path: "insights",
        name: "trackingInsights",
        component: () => import("../views/Tracking/TrackingInsights.vue"),
      },
    ],
  },
  // QR코드 관리 라우터 추가
  {
    path: "/qr",
    name: "qr",
    redirect: "/qr/management",
    children: [
      {
        path: "management",
        name: "qrManagement",
        component: QrManage,
      },
      {
        // QR 스캔 통계 탐색 페이지: /qr/stats?qr=id1,id2&from&to&g&metric (목록의 통계 버튼에서 진입)
        path: "stats",
        name: "qrStats",
        component: () => import("../views/QrManagement/QrStats.vue"),
      },
    ],
  },
  // 정품인증 관리 라우터 추가
  {
    path: "/product-auth",
    name: "productAuth",
    redirect: "/product-auth/qrcode",
    children: [
      {
        path: "qrcode",
        name: "qrCodeManagement",
        component: () => import("../views/ProductAuth/QrCodeManagement.vue"),
      },
    ],
  },
  // 홈페이지 편집기 라우터 추가
  {
    path: "/homepage/editor",
    name: "homepageEditor",
    component: HomepageEditor,
  },
  // 임시 DB 접근키 (발급/이력 탭 통합, SPEC-DBTEMP-001)
  {
    path: "/db-access",
    name: "dbAccess",
    component: () => import("../views/DbAccess/DbAccessManage.vue"),
  },
  // 채팅 상담 레포트 라우터 추가
  {
    path: "/consult-report/chat",
    name: "chatConsultReport",
    component: () => import("../views/ConsultReport/ChatConsultReportManage.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  linkActiveClass: "active",
});

/**
 * 메뉴에 안 보이는 화면(새 권한, meta.menu)을 주소로 열었나 — 메뉴와 같은 canMenu(REDIRECT-REQ 1).
 * 첫 이동이면 권한 정보를 기다린다. 못 받으면(실패·옛 inapi) 막지 않음. 막을 때 안내 한 번(같은 key)
 */
async function deniedMenu(to) {
  const key = to.meta.menu;
  if (!key) return false;
  const { loadIntrospect, loadPermLabels } = await import("@/api/standards");
  if (!store.state.introspect) await loadIntrospect();
  if (canMenu(permsOf(store.state.introspect), key)) return false;
  // 로그인 직후 첫 이동은 이름표를 아직 못 받았을 수 있다 — 먼저 받는다(영문 코드 노출 금지)
  if (!Object.keys(store.state.permLabels).length) await loadPermLabels();
  message.warning({ content: routeDeniedText(MENU_PERMS[key], store.state.permLabels), key: "ROUTE_PERMISSION_DENIED" });
  return true;
}

router.beforeEach(async (to, from, next) => {
  if (
    !localStorage.getItem("accessTokenCerti") &&
    to.path !== "/signin" &&
    to.path !== "/signup" &&
    to.path !== "/dev"
  ) {
    next("/signin");
  } else if (
    localStorage.getItem("accessTokenCerti") &&
    (to.path == "/signin" || to.path == "/signup")
  ) {
    store.dispatch("setUserInfo", {
      userName: localStorage.getItem("userNameCerti"),
      userImageUrl: localStorage.getItem("userImageUrlCerti"),
    });
    next("/dashboard");
  } else {
    store.dispatch("setUserInfo", {
      userName: localStorage.getItem("userNameCerti"),
      userImageUrl: localStorage.getItem("userImageUrlCerti"),
    });
    // 첫 화면 /dashboard 는 권한 표시가 없어 늘 열림(되돌아가기 반복 없음)
    if (await deniedMenu(to)) next("/dashboard");
    else next();
  }
});

// 화면 위치 헤더(X-Audit-Screen) 값 — 이동이 끝난 라우트 기준(W6 E1)
// 로그인한 뒤 첫 이동(새로 고침·로그인 직후)에 권한·모드 값을 한 번 읽는다(W6 2-2 can())
router.afterEach((to) => {
  setAuditScreen(to);
  if (localStorage.getItem("accessTokenCerti") && !store.state.introspect && to.path !== "/signin") {
    import("@/api/standards").then((m) => m.loadIntrospect());
  }
});
export default router;
